/**
 * <s-reveal> fades and lifts its [data-reveal] descendants into view as they
 * scroll onto the screen. Items already on screen reveal together with a short
 * stagger. Without JavaScript, or with reduced motion, items simply show.
 */
class SReveal extends HTMLElement {
  #observer;

  connectedCallback() {
    const items = this.querySelectorAll('[data-reveal]');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      for (const item of items) item.setAttribute('data-revealed', '');
      return;
    }
    this.#observer = new IntersectionObserver((entries) => {
      let order = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.style.setProperty('--reveal-delay', `${Math.min(order, 5) * 80}ms`);
        entry.target.setAttribute('data-revealed', '');
        this.#observer.unobserve(entry.target);
        order += 1;
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    for (const item of items) this.#observer.observe(item);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-reveal')) customElements.define('s-reveal', SReveal);
